import { useEffect, useState } from 'react';
import { InteractionConfig } from './types';

export default function Interaction(props: {
	shouldPlay: boolean;
	config: InteractionConfig;
	onLoaded: () => void;
	onDone: () => void;
	onError: (e: Error) => void;
}) {

	const [ws, setWS] = useState<undefined | WebSocket>()

	useEffect(() => {
		// connect to the websocket
		const w = new WebSocket('ws://localhost:42069/websocket')
		w.onclose = () => {
			console.log('websocket closed')
		}
		w.onerror = (err: any) => {
			props.onError(err)
		}
		w.onopen = () => {
			props.onLoaded()
		}
		w.onmessage = (msg) => {
			console.log('message:', msg)
			// We know something happened at this point, we can exit this and let the rest happen.
			// Give a timeout to space things out
			const j = JSON.parse(msg.data)
			if (j.messageType === "APIError") {
				props.onError(new Error(`Error running websocket payload: ''' ${msg.data} '''`))
			}

			setTimeout(() => {
				props.onDone();
			}, props.config.timeout)
		}
		setWS(w)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	if (props.shouldPlay && ws) {
		// send the tits payload message
		ws.send(props.config.websocketPayload)
		// Set timeout for 10 secnods to nack if we don't mark as done
		setTimeout(() => {
			window.parent.postMessage({ status: 'error', error: new Error("timeout hit for should play") }, '*');
		}, 10_000 + (props.config.timeout || 0))
	}

	return (
		<div>

		</div>
	);
}
